// fetch เข้า Pages Functions (/api/*) — ทุกตัวมี fallback ฝั่ง client
// เพื่อให้ dev/preview ใช้งานได้ก่อน DB/secrets พร้อม (source บอกที่มาของข้อมูล)
import { PRODUCTS } from '../data/catalog.js';
import { estimateOptions } from './shipping.js';

const j = (r) => {
  if (!r.ok) throw new Error(`api ${r.status}`);
  return r.json();
};

async function tryFetch(url, opts, timeoutMs = 6000) {
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    return await j(await fetch(url, { ...opts, signal: ctl.signal }));
  } finally {
    clearTimeout(t);
  }
}

// GET /api/catalog → [{sku,name,kw,web_category,blurb,price,weight_grams,imgs,colors,options,stock,sold_out}]
export async function getCatalog() {
  try {
    const d = await tryFetch('/api/catalog');
    if (Array.isArray(d.products) && d.products.length) {
      return { products: d.products.map(fromCatalogRow), source: d.source || 'live' };
    }
  } catch { /* fallback ด้านล่าง */ }
  return { products: PRODUCTS, source: 'seed' };
}

// แปลง v_catalog row → รูปแบบเดียวกับ PRODUCTS seed ที่ UI ใช้
function fromCatalogRow(r) {
  return {
    id: r.seo_slug || r.sku,
    sku: r.sku,
    cat: r.web_category,
    name: r.name,
    kw: r.kw || r.name,
    price: r.price != null ? Number(r.price) : null,
    weight: r.weight_grams || 0,
    blurb: r.blurb || '',
    blurb_en: r.blurb_en || undefined,
    colors: r.colors || [],
    options: r.options || [],
    imgs: (r.imgs && r.imgs.length) ? r.imgs : (r.image_path ? [r.image_path] : undefined),
    tag: r.sold_out ? 'sold' : undefined,
    stock: r.stock,
    related: Array.isArray(r.related) ? r.related : undefined,
  };
}

// POST /api/shipping/quote — ทางการ; fallback = client estimate สูตรเดียวกัน
export async function getQuote(items, country, subtotal) {
  try {
    const d = await tryFetch('/api/shipping/quote', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ items: items.map((i) => ({ sku: i.sku, qty: i.qty })), country }),
    });
    if (d.options) return { ...d, source: 'live' };
  } catch { /* fallback */ }
  return estimateOptions(
    items.map((i) => ({ weight_g: i.weight, qty: i.qty })),
    country,
    subtotal
  );
}

// POST /api/order → {order_no, next:'await_slip'|'paylink', paylink_url?}
export async function placeOrder(payload) {
  const d = await tryFetch('/api/order', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  }, 15000);
  return d;
}

// POST /api/pay/slip {order_no, image_base64, filename}
export async function submitSlip(orderNo, file) {
  const image_base64 = await new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(String(fr.result).split(',')[1]);
    fr.onerror = rej;
    fr.readAsDataURL(file);
  });
  return tryFetch('/api/pay/slip', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ order_no: orderNo, image_base64, filename: file.name }),
  }, 30000);
}

export async function getOrder(orderNo) {
  return tryFetch(`/api/order/${encodeURIComponent(orderNo)}`);
}

export async function lookupOrder(orderNo, email) {
  return tryFetch(`/api/track?order=${encodeURIComponent(orderNo)}&email=${encodeURIComponent(email)}`);
}
